module.exports = __webpack_public_path__ + "assets/images/coin-10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin-10.png
// module id = 1503
// module chunks = 1